import { useActionData } from "react-router-dom";
import { useEffect, useState } from "react";
import ForgotPasswordForm from "../../components/forms/ForgotPasswordForm";
import SmallAlert from "../../components/ui/alerts/SmallAlert";
import getAlertTitle from "../../utils/getAlertTitle";
import { statusAlertMap } from "../../lib/Constants";
import TwoColumnAuth from "../../components/layouts/TwoColumnAuth";
import LoadingPlaceholder from "../../components/ui/loading/LoadingPlaceholder";

function ForgotPasswordPage() {
  const actionData = useActionData();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [alertType, setAlertType] = useState(null);

  useEffect(() => {
    if (actionData?.status) {
      setLoading(false);
      setAlertType(statusAlertMap[actionData.status]);
      setMessage(actionData.message);
    }
  }, [actionData]);

  return (
    <main className="auth-page">
      <TwoColumnAuth>
        {loading && <LoadingPlaceholder />}

        {alertType && !loading && (
          <SmallAlert
            alert="True"
            title={getAlertTitle(alertType)}
            type={alertType}
            message={message}
            style={{ marginTop: 16, marginBottom: 16 }}
          />
        )}

        {!loading && alertType !== "success" && (
          <ForgotPasswordForm onSubmit={() => setLoading(true)} />
        )}
      </TwoColumnAuth>
    </main>
  );
}

export default ForgotPasswordPage;

export async function action({ request }) {
  const formData = await request.formData();
  const email = formData.get("email");

  const endpointPath = "account/forgot-password";
  const apiBaseUrl = process.env.REACT_APP_API_DOMAIN;
  const urlPath = `${apiBaseUrl}/${endpointPath}`;
  let response;

  try {
    response = await fetch(urlPath, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email }),
    });
  } catch (networkError) {
    return {
      status: 500,
      message: "Network error. Please try again later.",
    };
  }

  try {
    const data = await response.json();
    return {
      status: response.status,
      message: data.message,
    };
  } catch (parseError) {
    return {
      status: 500,
      message: "Unexpected server error. Please try again later.",
    };
  }
}
